// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"892e739f","453":"cb0f1ead","584":"94bbcbf5","626":"0cfbae8b"}[chunkId] + ".chunk.js";
};